import * as svg from "../../../assets/cog-icon.svg";

import {iconBuilder} from "./iconBuilder";

const CogIcon = iconBuilder(svg, "CogIcon", "0 0 21 21");

export default CogIcon;
